module.exports = __webpack_public_path__ + "media/assets/images/logos/aws_logo-4979c0ddbae08bfe9d45861af9566bda.png";